export default {
  meta: {
    title: '踩点宝管理',
  },
};
